import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";
import TextField from "@material-ui/core/TextField";
import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";
import { useSetRecoilState } from "recoil";
import useSWR from "swr";
import { IOmniumType } from "../../../../Models/Entities";
import {
  BASE_URL,
  extractId,
  fetcher,
  sendData,
} from "../../../../Models/Fetcher";
import { popupState, selectedTypesState } from "../../../../Store/atoms";
import { blurRoot, unBlurRoot } from "../../../../Utilities/DOMFunctions";

import "./styles.css";

const useStyles = makeStyles({
  select: {
    width: "100%",
  },
});

interface AddTypeProps {
  type: string;
}

export default ({ type }: AddTypeProps) => {
  const { handleSubmit, control } = useForm();
  const location = useLocation();
  const setPopup = useSetRecoilState(popupState);
  const tableId = extractId(location.pathname);
  const [selectedType, setSelectedType] = useState<IOmniumType | null>(null);
  const classes = useStyles();

  const url = BASE_URL + "codetables/" + tableId + "/omnium-types-" + type;

  const { data, error } = useSWR(BASE_URL + "omnium-types-" + type, fetcher);

  if (!data) {
    return <div className="">loading</div>;
  }

  blurRoot();

  const close = () => {
    unBlurRoot();
    setPopup(null);
  };

  const createType = async (formData: any) => {
    const response = await sendData(url, "POST", formData);
    window.location.reload();
    close();
  };

  const handleChange = (e: React.ChangeEvent<{ value: unknown }>) => {
    const value = e.target.value as string;
    const fetched = data.data as IOmniumType[];
    const selected = fetched.find((element) => element.id === +value);
    if (selected !== undefined) {
      setSelectedType(selected);
    }
  };

  const chooseType = async (e: any) => {
    const response = await sendData(url, "PUT", selectedType);
    window.location.reload();
    close();
  };

  return (
    <div className="add-type">
      <div className="create-type">
        <div className="create-type__heading">Create new type:</div>
        <form onSubmit={handleSubmit(createType)} className="create-type__form">
          <Controller
            name="type"
            control={control}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <TextField
                label="Omnium Type name"
                value={value}
                onChange={onChange}
                error={!!error}
                helperText={error ? error.message : null}
              />
            )}
            rules={{ required: "Type name required" }}
          />

          <Button
            style={{ marginTop: "1rem", width: "100%" }}
            variant="contained"
            type="submit"
            color="primary"
          >
            create type
          </Button>
        </form>
      </div>
      <div className="choose-type">
        <div className="create-type__heading">Choose existing type:</div>
        <FormControl className={classes.select}>
          <InputLabel id="omniumType-select-label">
            Choose existing type
          </InputLabel>
          <Select
            labelId="omniumType-select-label"
            id="omniumType-select"
            defaultValue={""}
            onChange={handleChange}
            className={classes.select}
          >
            {data.data.map((option: IOmniumType) => {
              return <MenuItem value={option.id}>{option.name}</MenuItem>;
            })}
          </Select>
          <Button
            style={{ marginTop: "1rem", width: "100%" }}
            variant="contained"
            type="submit"
            onClick={chooseType}
            color="primary"
          >
            select type
          </Button>
        </FormControl>
      </div>
      <Button style={{ marginTop: "2rem" }} onClick={close}>
        Cancel
      </Button>
    </div>
  );
};
